<script setup>
import { reactive, onMounted } from "vue";
import bus from "@/bus";

import PreloaderHeart from "@/components/PreloaderHeart.vue";

const data = reactive({
  show: false,
  visible: false,
});

const showModal = () => {
  data.show = true;
  setTimeout(() => {
    data.visible = true;
  }, 1);
};

const closeModal = () => {
  data.visible = false;
  setTimeout(() => {
    data.show = false;
  }, 500);
};

onMounted(() => {
  bus.global.on("modal.preloader:open", () => {
    showModal();
  });
  bus.global.on("modal.preloader:close", () => {
    closeModal();
  });
});
</script>

<template>
  <div v-if="data.show" class="modal" :class="{ modal_visible: data.visible }">
    <PreloaderHeart />
  </div>
</template>

<style lang="scss" scoped>
.modal {
  position: absolute;
  height: 100%;
  width: 100%;
  background: white;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999999;
}
</style>
